(function () {
  'use strict';

  function initAnnouncementBar() {
    var el = document.getElementById('siteAnnouncementMsg');
    if (!el) return;
    var messages = (el.dataset.messages || '').split('|||').filter(Boolean);
    if (messages.length > 1) {
      var index = 0;
      setInterval(function () {
        index = (index + 1) % messages.length;
        el.textContent = messages[index];
      }, 4500);
    }
  }

  function initNavToggle() {
    var toggle = document.getElementById('siteNavToggle');
    var list = document.getElementById('siteNavList');
    if (toggle && list) {
      toggle.addEventListener('click', function () {
        list.classList.toggle('site-open');
      });
    }
  }

  function initScrollTop() {
    var btn = document.getElementById('siteScrollTop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('site-visible', window.scrollY > 700);
    });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initHero(root) {
    var slides = root.querySelectorAll('.site-hero-slide');
    var dots = root.querySelectorAll('.site-hero-dot');
    var prevBtn = root.querySelector('.site-hero-arrow.site-prev');
    var nextBtn = root.querySelector('.site-hero-arrow.site-next');
    if (!slides.length) return;

    var current = 0;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('site-active');
      if (dots[current]) dots[current].classList.remove('site-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('site-active');
      if (dots[current]) dots[current].classList.add('site-active');
    }

    function start() {
      stop();
      timer = setInterval(function () { goTo(current + 1); }, 6000);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }

    start();
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });

    root.siteHeroCleanup = stop;
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.site-faq-item');
    items.forEach(function (item) {
      var question = item.querySelector('.site-faq-question');
      var answer = item.querySelector('.site-faq-answer');
      if (!question || !answer) return;
      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('site-active');
        items.forEach(function (other) {
          other.classList.remove('site-active');
          other.querySelector('.site-faq-question').setAttribute('aria-expanded', 'false');
          other.querySelector('.site-faq-answer').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('site-active');
          question.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 40 + 'px';
        }
      });
    });
  }

  /* Mirrors Shopify's money_format placeholders: {{amount}}, {{amount_no_decimals}},
     {{amount_with_comma_separator}}, {{amount_no_decimals_with_comma_separator}} */
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var value = '';
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number)) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    switch (format.match(placeholder)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function initProductForm(root) {
    var sectionId = root.dataset.sectionId;
    var jsonEl = document.getElementById('siteProductJson-' + sectionId);
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var money = function (cents) { return formatMoney(cents, moneyFormat); };

    var variantInput = document.getElementById('siteVariantId-' + sectionId);
    var priceEl = document.getElementById('sitePrice-' + sectionId);
    var unitPriceEl = document.getElementById('siteUnitPrice-' + sectionId);
    var skuEl = document.getElementById('siteSku-' + sectionId);
    var addToCartBtn = document.getElementById('siteAddToCart-' + sectionId);
    var qtyInput = document.getElementById('siteQty-' + sectionId);
    var optionSelects = root.querySelectorAll('.site-variant-option[data-section="' + sectionId + '"]');

    function currentSelections() {
      var selections = [];
      optionSelects.forEach(function (control) {
        var idx = parseInt(control.dataset.optionIndex, 10);
        if (control.tagName === 'SELECT') {
          selections[idx] = control.value;
        } else if (control.checked) {
          selections[idx] = control.value;
        }
      });
      return selections;
    }

    function variantMatchesSelections(variant, selections) {
      return variant.options.every(function (opt, i) {
        return selections[i] === undefined || selections[i] === opt;
      });
    }

    function findMatchingVariant() {
      var selections = currentSelections();
      return variants.find(function (variant) {
        return variantMatchesSelections(variant, selections);
      });
    }

    /* Disable option values that have no available variant given the other controls' current values */
    function updateOptionAvailability() {
      var selections = currentSelections();
      optionSelects.forEach(function (control) {
        var index = parseInt(control.dataset.optionIndex, 10);
        if (control.tagName === 'SELECT') {
          Array.prototype.forEach.call(control.options, function (optionEl) {
            var testSelections = selections.slice();
            testSelections[index] = optionEl.value;
            var hasAvailableMatch = variants.some(function (variant) {
              return variantMatchesSelections(variant, testSelections) && variant.available;
            });
            optionEl.disabled = !hasAvailableMatch;
          });
        } else {
          var testSelections = selections.slice();
          testSelections[index] = control.value;
          var hasAvailableMatch = variants.some(function (variant) {
            return variantMatchesSelections(variant, testSelections) && variant.available;
          });
          control.disabled = !hasAvailableMatch;
          var card = control.closest('.site-variant-card');
          if (card) card.classList.toggle('site-unavailable', !hasAvailableMatch);
        }
      });
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="site-price-sale">' + money(variant.price) + '</span>' +
            '<span class="site-price-compare">' + money(variant.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + money(variant.price) + '</span>';
        }
      }
      if (unitPriceEl) {
        if (variant.unit_price && variant.unit_price_measurement) {
          var m = variant.unit_price_measurement;
          var refValue = m.reference_value !== 1 ? m.reference_value : '';
          unitPriceEl.textContent = money(variant.unit_price) + '/' + refValue + m.reference_unit;
          unitPriceEl.style.display = '';
        } else {
          unitPriceEl.style.display = 'none';
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        var label = addToCartBtn.querySelector('span') || addToCartBtn;
        label.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (qtyInput && variant.quantity_rule) {
        qtyInput.min = variant.quantity_rule.min || 1;
        qtyInput.step = variant.quantity_rule.increment || 1;
        if (variant.quantity_rule.max) {
          qtyInput.max = variant.quantity_rule.max;
        } else {
          qtyInput.removeAttribute('max');
        }
        var current = parseInt(qtyInput.value, 10) || qtyInput.min;
        if (current < qtyInput.min) qtyInput.value = qtyInput.min;
      }
      var mainImg = document.getElementById('siteGalleryMain-' + sectionId);
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        mainImg.src = variant.featured_image.src;
        var thumbs = root.querySelectorAll('.site-product-gallery__thumb');
        thumbs.forEach(function (t) {
          t.classList.toggle('site-active', parseInt(t.dataset.mediaId, 10) === variant.featured_image.id);
        });
      }
      var stickyPriceEl = document.getElementById('siteStickyPrice-' + sectionId);
      if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);
      var stickyCta = document.querySelector('[data-sticky-bar] [data-sticky-add-to-cart]');
      if (stickyCta) {
        stickyCta.disabled = !variant.available;
        stickyCta.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      updateUrl(variant);
    }

    optionSelects.forEach(function (control) {
      control.addEventListener('change', function () {
        updateOptionAvailability();
        updateForVariant(findMatchingVariant());
      });
    });
    updateOptionAvailability();

    var decreaseBtn = root.querySelector('[data-qty-decrease]');
    var increaseBtn = root.querySelector('[data-qty-increase]');
    if (qtyInput && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var step = parseInt(qtyInput.step, 10) || 1;
        var min = parseInt(qtyInput.min, 10) || 1;
        var val = Math.max(min, (parseInt(qtyInput.value, 10) || min) - step);
        qtyInput.value = val;
      });
      increaseBtn.addEventListener('click', function () {
        var step = parseInt(qtyInput.step, 10) || 1;
        var max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
        var val = Math.min(max, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = val;
      });
    }

    var thumbs = root.querySelectorAll('.site-product-gallery__thumb');
    var mainImg = document.getElementById('siteGalleryMain-' + sectionId);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('site-active'); });
        thumb.classList.add('site-active');
        if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
      });
    });

    var tabsRoot = root.querySelector('[data-tabs]');
    if (tabsRoot) {
      var tabTriggers = tabsRoot.querySelectorAll('[data-tab-trigger]');
      tabTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var id = trigger.dataset.tabTrigger;
          tabsRoot.querySelectorAll('[data-tab-trigger]').forEach(function (t) {
            t.classList.toggle('site-active', t === trigger);
          });
          tabsRoot.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
            panel.classList.toggle('site-active', panel.dataset.tabPanel === id);
          });
        });
      });
    }

    var stickyBar = document.querySelector('[data-sticky-bar]');
    if (stickyBar) {
      var stickyCta = stickyBar.querySelector('[data-sticky-add-to-cart]');
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          if (addToCartBtn) addToCartBtn.click();
        });
      }
      if (addToCartBtn && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          stickyBar.classList.toggle('site-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -60% 0px' });
        observer.observe(addToCartBtn);
      }
    }
  }

  function initCollectionFilters(root) {
    var panel = root.querySelector('[data-filters-panel]');
    var backdrop = root.querySelector('[data-filters-backdrop]');
    var openBtn = root.querySelector('[data-filters-open]');
    var closeBtn = root.querySelector('[data-filters-close]');
    if (!panel || !backdrop || !openBtn) return;

    function open() {
      panel.classList.add('site-active');
      backdrop.classList.add('site-active');
      document.documentElement.classList.add('site-scroll-locked');
    }
    function close() {
      panel.classList.remove('site-active');
      backdrop.classList.remove('site-active');
      document.documentElement.classList.remove('site-scroll-locked');
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    root.querySelectorAll('.site-filter-group__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var body = toggle.nextElementSibling;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (body) body.style.display = expanded ? 'none' : '';
      });
    });
  }

  function initSection(section) {
    var type = section.dataset.sectionType;
    if (type === 'site-hero') initHero(section);
    if (type === 'site-faq') initFaq(section);
    if (type === 'site-product-main') initProductForm(section);
    if (type === 'site-collection-grid') initCollectionFilters(section);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="site-hero"], [data-section-type="site-faq"], [data-section-type="site-product-main"], [data-section-type="site-collection-grid"]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initNavToggle();
    initScrollTop();
    initAll(document);
  });

  /* Re-init when the theme editor loads/reloads a section (live preview) */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Tear down carousel timers before a section is unloaded/reloaded in the editor */
  document.addEventListener('shopify:section:unload', function (event) {
    var hero = event.target.querySelector('[data-section-type="site-hero"]');
    if (hero && typeof hero.siteHeroCleanup === 'function') hero.siteHeroCleanup();
  });
})();
